/* Oh!My Snacks — Homepage interactions */
(function () {
  // FAQ accordion
  document.querySelectorAll('.oms-faq__item').forEach(function (item) {
    var btn = item.querySelector('.oms-faq__q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
    });
  });

  // UGC carousel
  document.querySelectorAll('.oms-ugc__carousel').forEach(function (root) {
    var track = root.querySelector('.oms-ugc__track');
    if (!track) return;
    var card = track.querySelector('.oms-ugc__card');
    function step() { return card ? card.getBoundingClientRect().width + 16 : 240; }
    var prev = root.querySelector('.oms-ugc__arrow--prev');
    var next = root.querySelector('.oms-ugc__arrow--next');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  // ========================================================
  // HERO VIDEO — plays natively (autoplay muted playsinline) on all
  // regions and devices. JS only: (1) honour reduced-motion, and
  // (2) fade the poster image out once playback starts.
  // ========================================================
  (function () {
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-oms-hero-video]').forEach(function (video) {
      if (prefersReduced) {
        // Keep the poster image, never play the video
        video.removeAttribute('autoplay');
        video.pause();
        video.style.display = 'none';
        return;
      }
      // Nudge playback in case a browser ignored the autoplay attribute
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* autoplay blocked, poster stays */ });

      // Fade the poster image once the video is actually playing
      function hidePoster() {
        var poster = video.parentElement && video.parentElement.querySelector('.oms-hero__poster');
        if (poster) poster.classList.add('is-hidden');
      }
      if (!video.paused) hidePoster();
      video.addEventListener('playing', hidePoster, { once: true });
    });
  })();

  // ========================================================
  // STICKY MOBILE CTA — show on scroll past hero, hide on scroll-up
  // ========================================================
  (function () {
    var cta = document.querySelector('[data-oms-sticky-cta]');
    if (!cta) return;
    var hero = document.querySelector('.oms-hero');
    var lastY = window.pageYOffset || 0;
    var ticking = false;
    var SHOW_AFTER = hero ? Math.max(280, hero.offsetHeight * 0.6) : 360;

    function update() {
      var y = window.pageYOffset || 0;
      var scrollingDown = y > lastY + 4;
      var scrollingUp = y < lastY - 4;
      var nearBottom = (window.innerHeight + y) >= (document.documentElement.scrollHeight - 80);

      if (y > SHOW_AFTER && !nearBottom && !scrollingUp) {
        cta.classList.add('is-visible');
      } else if (scrollingUp || y <= SHOW_AFTER || nearBottom) {
        cta.classList.remove('is-visible');
      }
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  })();
})();
